"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var onClick = _a.onClick;
    return onClick &&
        "\n  &:hover {\n    cursor: pointer;\n  }\n";
});
